export const FIVE_YEAR_CATEGORIES = {
  Health:
    "Describe what your body, energy, and physical health look like. Write it as if it is already real.",

  Mind:
    "Describe your mental state, emotional clarity, and inner peace. Write it as if it is already real.",

  Career:
    "Describe the work you do, the role you hold, and the impact you have. Write it as if it is already real.",

  Business:
    "Describe the business, brand, or platform you have built. Write it as if it is already real.",

  Finance:
    "Describe your financial reality — the freedom, the stability, the life it enables. Write it as if it is already real.",

  Relationships:
    "Describe the people in your life and what those connections look like. Write it as if it is already real.",

  Family:
    "Describe your family life — your home, your closest people, the life you have built together. Write it as if it is already real.",

  Environment:
    "Describe where you live, how your home feels, and what your daily surroundings look like. Write it as if it is already real.",

  Habits:
    "Describe your daily routines, rituals, and disciplines. Write it as if it is already real.",

  Learning:
    "Describe what you know, the skills you have built, and who you are becoming. Write it as if it is already real.",

  Passion:
    "Describe the creative work, art, or passion project you have made real. Write it as if it is already real.",
};